import { useEffect, useState } from "react";
import { ClientReports } from "../../../../redux/models/clientReports";
import { ReportContent } from "./reportContent";

export const Report = ({ type, clientId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [report, setReport] = useState(null);

  const getReport = async () => {
    try {
      setError(null);
      setReport(null);
      setLoading(true);
      const response = await ClientReports.getEmbed(clientId, type);
      setReport(response.data);
    } catch (err) {
      setError(err);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getReport();
  }, [type, clientId]);

  return (
    <ReportContent loading={loading} error={error?.message} url={report?.url} />
  );
};
